
import axios from "axios"
import {defineComponent} from 'vue'
import {Locales} from "@/i18n/locales";
import Dropdown from 'primevue/dropdown';


export default defineComponent({
  name: "CategoryPicker",
  components: {Dropdown},
  data() {
    return {
      options: [],
      isActive: false,
      selected: null as any
    }
  },
  props: {
    api: {type: String, required: true},
    name: {type: String, required: true},
    value: {type: Number, required: true},
    clearable: {type: Boolean, required: false, default: true},
    filter: {type: Boolean, required: false, default: true},
  },
  computed: {
    lang(): Locales {

      return this.$store.state.language

    }
  },

  methods: {
    getRequestURI(api: string) {
      // check for additional request params with ? in URI, eg. for api?param=1&lang=de to concatenate URI
      return api.includes('?') ? api + '&lang=' + this.$store.state.language : api + '?lang=' + this.$store.state.language
    },
    getOptions() {
      axios.get(this.getRequestURI(this.api)).then(res => this.options = res.data.sort((a:any,b:any)  => (a.LABEL > b.LABEL) ? 1 : -1))
    },
    select(value: number) {
      this.selected = value
      this.$emit('select', {key: this.name, value: value})
    }
  },
  watch: {
    selected() {
      console.log("watch selected", this.selected)
    },
    api: {
      handler() {
        this.getOptions()
      },
      immediate: true
    },
    lang() {
      this.getOptions()
    }
  },
  beforeMount() {
    this.select(this.value)
  }
})
